import { useNavigate } from "react-router-dom";
import { TableItemId } from "../../../../components/tables/TableWidget";
import { receptionRoutes } from "../../../../router/routesConstants";
import { TableItemType } from "../../../../components/tables/tableContext/TableContext";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../components/actionMenu/ActionMenu";

function MonitorQuarantineActionButtons({
  crudData,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: any;
}) {
  const navigate = useNavigate();

  const editProduct = () => {
    navigate(
      `/${receptionRoutes.reception}/${receptionRoutes.quarantine}?reception=${crudData.idFluxReceptie}&createdAt=${crudData.createdAt}&page=1`,
    );
  };
  const items: ActionMenuItem[] = [
    {
      id: "view-quarantine",
      label: "Vezi carantina",
      icon: "QUARANTINE",
      tooltip: "Deschide carantina receptiei pentru acest produs.",
      onClick: editProduct,
    },
  ];

  return (
    <div className="text-right">
      <ActionMenu
        items={items}
        minItemsForMenu={2}
        title={crudData?.numeProdus}
        ariaLabel="Actiuni pentru produsul monitorizat in carantina"
      />
    </div>
  );
}

export default MonitorQuarantineActionButtons;
